import { render } from "./MoveToListAction.vue?vue&type=template&id=d201ce3c"
import script from "./MoveToListAction.vue?vue&type=script&lang=ts"
export * from "./MoveToListAction.vue?vue&type=script&lang=ts"
script.render = render

export default script